// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".monitor-card-field-monitor-d49e9 .monitor-card-field-instances-c91eb{margin-left:8px}.monitor-card-field-monitor-d49e9 .monitor-card-field-instances-c91eb a{padding-left:0!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"monitor": "monitor-card-field-monitor-d49e9",
	"instances": "monitor-card-field-instances-c91eb"
};
export default ___CSS_LOADER_EXPORT___;
